export default {"src":"/_next/static/media/round-star.90764c74.svg","height":87,"width":87,"blurWidth":0,"blurHeight":0};